import React, { useState, useEffect } from 'react';
import PubSub from "services/PubSub";
import Modal from "components/Modal";
import { actionsType } from 'config/constants';
import DeliverySelector from './DeliverySelector';
import style from './style.scss';//NOSONAR

let actions = [];

const ModalDeliverySelector = () => {
    const [settings, setSettings] = useState({successCallback : () => {}});

    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.DELIVERY_SELECTOR_OPEN, _open));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];

        }
    }, []);

    const  _open = (payload) => {
        if (payload.value) {
            setSettings(payload.value);
        } else {
            if(settings) {
                setSettings(null);
            }
        }
    }

    return (
        <Modal customClass={'delivery-selector-wrap'} actionOpen={actionsType.MODAL.DELIVERY_SELECTOR_OPEN} actionClose={actionsType.MODAL.DELIVERY_SELECTOR_CLOSE}>
            <DeliverySelector settings={settings}/>
        </Modal>);
}

export default ModalDeliverySelector;

